import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapc4c.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapCloudForCustomer_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SapCloudForCustomer_DisplayText)
    ]
})
export class SapC4CLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Url
    })
    public url?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public username?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
